<template>
  <div class="integral">
    <van-notice-bar v-if="integertips" scrollable :text="integertips" />
    <div style="position: relative">
      <div class="header">
        <div class="topWrap flex-js-ac">
          <div class="flex-ac">
            <p class="mr8 f22 flex-ac">
              <img src="../../assets/images/integral/money.png" alt="" />
              {{ integral }}
            </p>
            <router-link :to="{ path: '/integralTask' }" class="taskBtn" tag="div">
              去赚金币
            </router-link>
            <!--            <p @click="integralClick" class="f12">去赚金币</p>-->
          </div>
          <div class="flex-ac">
            <router-link :to="{ path: '/integraldetails' }" class="f12" tag="div">
              金币明细
            </router-link>
            <div class="f10">&nbsp;&nbsp;|&nbsp;&nbsp;</div>
            <router-link :to="{ path: '/integralrule' }" class="f12" tag="div">
              金币规则
            </router-link>
          </div>
        </div>
      </div>
      <div class="content">
        <!--        <div class="titleWrap flex-jc-ac">-->
        <!--          <img src="../../assets/images/integral/left.png" />-->
        <!--          <span class="signLabel">每日签到</span>-->
        <!--          <img src="../../assets/images/integral/right.png" />-->
        <!--        </div>-->
        <div class="integralSeven flex-ac flex-w" v-if="newSignGear == 0">
          <div
            :class="[item.issignin ? 'active' : 'grey', 'item']"
            :key="index"
            v-for="(item, index) in dateList"
          >
            <div v-if="index + 1 < dateList.length">
              <p class="f12">第{{ index + 1 }}天</p>
              <p class="f13 fb">{{ item.integralcount }}金币</p>
              <img src="../../assets/images/integral/money.png" />
            </div>
            <div class="lastDay" v-else>
              <p class="f12">第{{ index + 1 }}天</p>
              <p class="f13 fb">{{ item.integralcount }}金币</p>
              <p class="reward">连续签到{{ dateList.length }}天可得{{ rewardNum }}金币</p>
              <img src="../../assets/images/integral/money.png" />
            </div>
          </div>
        </div>
        <div class="integralSeven signinlist" v-else-if="newSignGear == 1">
          <div class="title flex-js-ac f14">
            <van-icon name="arrow-left" color="#6C6C6C" size="0.14rem" @click="beforeDate" />
            <div style="color: #6c6c6c">{{ curDate }}</div>
            <van-icon name="arrow" color="#6C6C6C" size="0.14rem" @click="afterDate" />
          </div>
          <ul class="flex-js-ac">
            <li class="flex-1 f12" v-for="item of week">{{ item }}</li>
          </ul>
          <ol class="flex flex-w">
            <li
              v-if="curmonth != month || isunfold || isshow_beforeempty"
              v-for="i of beforeempty"
              class="empty"
            ></li>
            <li
              class="flex-s f12"
              v-for="(item, index) of curmonth != month || isunfold ? daylist : daylist_1"
              :key="index"
            >
              <div
                class="item"
                @click="signinItem(item, index + 1)"
                :class="{
                  today_nosignin: item.istoday == 1 && item.issigin == 0,
                  today_yessignin: item.istoday == 1 && item.issigin == 1,
                  notoday_nosignin_beforedays:
                    item.isbeforedays == 1 &&
                    item.isReplenish == 0 &&
                    item.issigin == 0 &&
                    item.istoday == 0,
                  notoday_yessignin: item.istoday == 0 && (item.issigin == 1 || item.issigin == 2),
                  notoday_nosignin:
                    item.isbeforedays != 1 &&
                    item.istoday == 0 &&
                    item.issigin == 0 &&
                    item.isReplenish == 0
                }"
              >
                <img
                  v-if="
                    (item.isbeforedays != 1 && item.issigin == 0 && item.isReplenish == 0) ||
                    item.issigin == 2
                  "
                  src="../../assets/images/integral/money.png"
                />

                <img v-else-if="item.url && item.issigin == 1" :src="item.url" />

                <p
                  class="f13"
                  v-if="item.isReplenish == 1 && item.issigin == 0"
                  style="color: #ffae63"
                >
                  补签
                </p>
                <p
                  class="f12"
                  v-else-if="item.isbeforedays == 1 && item.isReplenish == 0 && item.issigin == 0"
                  style="color: #e6ded3"
                >
                  未签到
                </p>

                <p class="f12">{{ item.istoday == 0 ? month + '.' + item.day : '今日' }}</p>
              </div>
            </li>
          </ol>
          <p
            class="f14 flex-jc-ac"
            style="margin-top: 0.1rem"
            v-if="curmonth == month"
            @click="isunfold = !isunfold"
          >
            {{ isunfold == false ? '展开' : '收起' }}
            <van-icon
              size="0.12rem"
              color="#6C6C6C"
              style="margin-left: 0.04rem"
              :name="isunfold == false ? 'arrow-down' : 'arrow-up'"
            />
          </p>
        </div>
        <div @click="goLuck" class="luckDraw" v-if="luckFlag">
          <img src="../../assets/images/integral/luckDraw.gif?v=1" />
        </div>
        <div class="titleWrap titleWrap2 flex-jc-ac" v-if="convertcoupon.length">
          <img src="../../assets/images/integral/left.png" />
          <span class="signLabel red">金币兑换优惠券</span>
          <img src="../../assets/images/integral/right.png" />
        </div>
        <div class="couponList">
          <ul>
            <li :key="index" v-for="(item, index) in convertcoupon">
              <div class="item">
                <div class="price">
                  <span>¥</span>
                  <span>{{ item.money }}</span>
                </div>
                <div class="f12">{{ item.name }}</div>
                <div>
                  <div
                    :class="[item.isexchange ? 'active' : 'grey', 'exchangeBtn']"
                    @click="exchangeDialog(item, 0)"
                  >
                    {{ item.isexchange ? item.integralcount + '金币' : '已兑换' }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="titleWrap titleWrap3 flex-jc-ac" v-if="goodsList.length">
          <img src="../../assets/images/integral/left.png" />
          <span class="signLabel red">金币兑好礼</span>
          <img src="../../assets/images/integral/right.png" />
        </div>
        <div class="goodsList">
          <div
            :key="index"
            @click="exchangeDialog(item, 1)"
            class="item"
            v-for="(item, index) in goodsList"
          >
            <div class="img">
              <img :src="item.img_path" />
              <img src="/static/images/shouqing.png" class="soldout" v-if="item.islimit == 2" />
              <img src="/static/images/soldout.png" class="soldout" v-else-if="item.issale == 0" />
            </div>
            <p class="name">{{ item.name }}</p>
            <div class="flex-js-as mt6">
              <div>
                <div class="oh" v-if="item.money != '0.00'">
                  <span class="f12 red fl lh12">¥</span>
                  <span class="f15 red fl lh12">{{ item.IntegerMoney }}</span>
                  <span class="f12 red fl lh12">{{ item.decimalPlaceMoney }}</span>
                </div>
                <div class="oh mt6">
                  <span class="yellow fl lh12" v-if="item.money != '0.00'">+</span>
                  <span class="f15 fl lh12 yellow">{{ item.integralcount }}</span>
                  <span class="yellow fl lh12">金币</span>
                </div>
              </div>
              <div class="costPrice">¥{{ item.cost_price }}</div>
            </div>
          </div>
        </div>
        <div
          v-if="isshow"
          class="bottomLine f18"
          style="color: cornflowerblue"
          @click="$router.push('/')"
        >
          点击跳转☞参与更多双12活动
        </div>
        <div class="bottomLine f12" v-else-if="goodsList.length && finished">
          —— 我是有底线的 ——
        </div>
      </div>
    </div>
    <div class="floatBtn_new">
      <img
        v-if="isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
    </div>
    <van-overlay :show="popFlag" z-index="99999">
      <div class="popWrapper">
        <div class="block">
          <div>
            <img
              src="https://ckysrestatic.ckc8.com/Uploads/static/images/integral/signSuccess.png"
            />
          </div>
          <van-icon @click="closeAct" name="close" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import Vue from 'vue'
import { NoticeBar } from 'vant'

Vue.use(NoticeBar)
export default {
  name: 'integralCenter',
  data() {
    return {
      dateList: null,
      convertcoupon: [],
      goodsList: [],
      type: null, // 0-金币 1-商品 2-优惠卷
      luckFlag: null,
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 1,
      noDataText: '—— 客官，木有啦~ ——',
      integral: null,
      showflag: 0,
      empty: false,
      popFlag: false,
      rewardNum: 0, // 连续七天得积分
      integertips: '',
      isshow: false,
      week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      curDate: '',
      curDateData: '',
      year: '',
      curyear: '',
      month: '',
      curmonth: '',
      newSignGear: -1,
      beforeempty: 0, // 该month 起始日之前空白天数
      afterempty: 0, // 该month 结束日之后空白天数
      monthdays: 0, // 该month 天数
      daylist: [], // 该月签到list
      daylist_1: [], // 该月签到list，仅两行数据
      firstweekday: 0, // 该month 起始日星期几
      endweekday: 0, // 该month 结束日星期几
      isunfold: false,
      isshow_beforeempty: false, // 是否显示该month 起始日之前空白天数
      isnewpersontask: 0,
      newpersonjump: ''
    }
  },
  created() {},
  activated() {
    let personalInformation = JSON.parse(sessionStorage.getItem('personal_information'))
    this.integral = personalInformation ? personalInformation.integral : null

    this.getIntegralInfo()
  },
  mounted() {
    let endtime = new Date('2022/12/12 23:59:59').getTime(),
      curtime = new Date().getTime()
    if (curtime <= endtime) {
      this.isshow = true
    } else {
      this.isshow = false
    }
    this.$newuserFn((data) => {
      if (data.code == 200) {
        this.isnewpersontask = data.isnewpersontask
        this.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
      }
    })
  },

  methods: {
    getSigninList: function (month, type) {
      var url = this.$ajax.getSignRecord_URL + '?month=' + month
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          let isbeforedays = 1,
            todayIndex = -1
          if (this.curyear > this.year) {
            isbeforedays = 1
          } else if (this.curyear < this.year) {
            isbeforedays = 0
          } else if (this.curmonth > this.month) {
            isbeforedays = 1
          } else if (this.curmonth < this.month) {
            isbeforedays = 0
          }
          this.daylist = res.data.daylist.map((item, index) => {
            item.day = index + 1
            item.isbeforedays = isbeforedays
            if (item.istoday == 1) {
              isbeforedays = 0
              todayIndex = index + 1
            }
            return item
          })
          if (todayIndex + this.beforeempty <= 7) {
            let end_i =
              (parseInt((this.daylist.length + this.beforeempty) / 7) * 7) / 2 - this.beforeempty
            this.daylist_1 = this.daylist.slice(0, end_i)
            console.log('daylist_1:', this.daylist_1, '，start_i:', 0, '，end_i:', end_i)
          } else {
            let curline = Math.ceil((todayIndex + this.beforeempty) / 7) // 当前日期所在第几行
            let start_i = (curline - 1) * 7 - 7 // 起始位置
            let end_i = curline * 7 - this.beforeempty // 截止位置
            if (end_i >= this.daylist.length) {
              end_i = this.daylist.length
            }
            this.daylist_1 = this.daylist.slice(
              start_i == 0 ? start_i : start_i - this.beforeempty,
              end_i
            )
            console.log(
              'daylist_1:',
              this.daylist_1,
              '，curline:',
              curline,
              '，start_i:',
              start_i,
              '，end_i:',
              end_i
            )
          }
          this.isshow_beforeempty = this.daylist_1[0].day == 1 ? true : false
          if (type == 'init') this.signinItem({}, new Date().getDate())
        }
      })
    },
    signinItem: function (item, day) {
      var url = this.$ajax.userSign_URL,
        data = { signDay: this.curDateData + '-' + day }
      var f = () => {
        this.$customRequestAjax.post(url, data).then((res) => {
          if (res.data.code == 200) {
            this.getSigninList(this.curDateData)
            this.$dialog
              .alert({
                message: res.data.msg,
                className: 'percen_button_alert',
                confirmButtonColor: '#FFFCFC',
                confirmButtonText: '我知道了',
                closeOnPopstate: false,
                messageAlign: 'center'
              })
              .then(() => {
                if (res.data.goldnum)
                  this.integral = parseInt(this.integral) + parseInt(res.data.goldnum)
              })
              .catch(() => {})
          }
        })
      }
      if (
        (item.istoday == 1 && item.day == data.signDay && item.issigin == 1) ||
        (item.istoday == 0 &&
          item.day != data.signDay &&
          (item.issigin == 1 || item.issigin == 2 || (item.issigin == 0 && item.isReplenish == 0)))
      ) {
        return
      } else if (
        item.istoday == 0 &&
        item.day != data.signDay &&
        item.issigin == 0 &&
        item.isReplenish == 1
      ) {
        this.$dialog
          .confirm({
            message: '补签需要消耗' + item.signednum + '金币',
            className: 'collect_button_alert',
            cancelButtonColor: '#FC0324',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnPopstate: true
          })
          .then(() => {
            // 点击确认按钮
            if (item.signednum) this.integral = parseInt(this.integral) - parseInt(item.signednum)
            f()
          })
          .catch(function () {})
      } else {
        f()
      }
    },
    dateInit: function (type) {
      if (type == 'init') {
        this.year = new Date().getFullYear()
        this.month = new Date().getMonth() + 1
        this.curyear = this.year
        this.curmonth = this.month
      }
      this.curDate = this.year + '年' + this.month + '月'
      this.curDateData = this.year + '-' + this.month
      this.monthdays = this.getMonthDays(this.year, this.month)
      this.firstweekday = this.getWeekDays(this.year, this.month, 1)
      this.endweekday = this.getWeekDays(this.year, this.month, this.monthdays)
      this.beforeempty = this.firstweekday
      this.endweekday = this.week.length - (this.endweekday + 1)
      this.getSigninList(this.curDateData, type)
    },
    beforeDate() {
      this.daylist = []
      if (this.month <= 1) {
        this.month = 12
        this.year--
      } else {
        this.month--
      }
      this.dateInit()
    },
    afterDate() {
      this.daylist = []
      if (this.month >= 12) {
        this.month = 1
        this.year++
      } else {
        this.month++
      }
      this.dateInit()
    },
    //传入年份和月份 获取该年对应月份的天数
    getMonthDays(year, month) {
      var thisDate = new Date(year, month, 0) //当天数为0 js自动处理为上一月的最后一天
      return thisDate.getDate()
    },
    //传入年份和月份 获取该年该月第一天对应的week
    getWeekDays(year, month, day) {
      var thisDate = new Date(year + '/' + month + '/' + day),
        week = (thisDate.getDay() + 6) % 7
      return week
    },
    newpersontask() {
      window.location = this.newpersonjump
    },
    // 关闭弹窗
    closeAct() {
      this.popFlag = false
    },
    // 判断是否已签到
    // getIsSignData: function () {
    //   this.getUserInfo()
    // let url = this.$ajax.getTopMessage_URL
    // customRequestAjax(url).then((res) => {
    //   if (res.data.code === 200) {
    //     if (!res.data.is_signin && this.newSignGear != 1) {
    //       this.signNow()
    //     } else {
    //       this.getUserInfo()
    //     }
    //   } else {
    //     this.getUserInfo()
    //   }
    // })
    // },

    // 签到
    signNow() {
      let that = this,
        url = this.$ajax.signIn_URL
      this.$customRequestAjax.post(url).then((res) => {
        if (res.data.code === 200) {
          if (localStorage.getItem('ckc4_home_top_message')) {
            let homeHeadSignin = JSON.parse(localStorage.getItem('ckc4_home_top_message'))
            homeHeadSignin.is_signin = 1
            localStorage.setItem('ckc4_home_top_message', JSON.stringify(homeHeadSignin))
          }
          this.popFlag = true
        }
        this.getUserInfo()
      })
    },

    // 获取用户金币
    getUserInfo() {
      let that = this,
        url = this.$ajax.getMeInfo_URL
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.integral = res.data.integral
          that.getList()
        }
      })
    },

    // 获取签到周期、优惠券列表
    getIntegralInfo() {
      var that = this,
        url = this.$ajax.getIndex_Goldmall_URL
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.newSignGear = Number(res.data.newSignGear)
          if (this.newSignGear == 1) {
            this.getUserInfo()
            this.dateInit('init')
          } else {
            this.signNow()
          }
          if (isWeixin()) {
            fenxiang({
              title: encodeURIComponent(res.data.sharetitle ? res.data.sharetitle : ''),
              desc: encodeURIComponent(res.data.sharedesc ? res.data.sharedesc : ''),
              imgx: res.data.shareimg,
              dataStr: 'type=integralindex',
              type: 'integralindex',
              path: 'integralCenter'
            })
          }
          let convertcoupon = res.data.convertcoupon,
            dateList = res.data.dailysignin,
            rewardNum = 0
          dateList.forEach((item) => {
            rewardNum += parseInt(item.integralcount)
          })

          that.rewardNum = rewardNum
          that.dateList = dateList
          that.luckFlag = res.data.isdrowprize
          that.integertips = res.data.integertips

          // 判断用户金币是否可以兑换当前商品
          convertcoupon.forEach((item) => {
            item.status = parseInt(this.integral) >= parseInt(item.integralcount) ? 1 : 0
          })
          that.convertcoupon = convertcoupon
        }
      })
    },
    // 获取金币兑换商品列表
    getList() {
      var that = this,
        url =
          this.$ajax.getIntegralDiscountItemList_URL +
          '?pageno=' +
          this.nowPage +
          '&pagesize=' +
          this.pagesize
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          let list = res.data.integraldiscountlist
          list.forEach((item) => {
            let index = item.money.indexOf('.') + 1

            item.IntegerMoney = item.money.slice(0, index)
            item.decimalPlaceMoney = item.money.slice(index)
            // 判断用户金币是否可以兑换当前商品
            item.status = parseInt(this.integral) >= parseInt(item.integralcount) ? 1 : 0
          })
          if (that.nowPage === 1) {
            that.goodsList = list
            that.refresh = false
          } else {
            that.goodsList = that.goodsList.concat(list)
          }
          that.loading = false
          that.finished = list.length < that.pagesize ? true : false
          if (that.goodsList.length <= 0) {
            that.finished = true
            that.empty = true
          }
        }
      })
    },
    integralClick() {
      var that = this
      that.$router.push('/integraldetails')
    },
    // 立即兑换-弹窗
    exchangeDialog(item, type) {
      if (type == 0) {
        // 兑换优惠券
        if (item.status == 0) {
          this.$dialog
            .alert({
              message: '金币不足，兑换失败！',
              className: 'percen_button_alert PopupIntegral PopupSmall',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '去赚金币',
              closeOnPopstate: false,
              showCancelButton: true,
              cancelButtonText: '知道了'
            })
            .then(() => {
              this.$router.push({
                path: '/integralTask'
              })
            })
            .catch(() => {})
          return
        }
        if (item.isexchange) {
          // 有兑换资格
          this.$dialog
            .confirm({
              message: '仅部分产品可用，确认兑换优惠券？',
              className: 'collect_button_alert',
              confirmButtonColor: '#FFFCFC',
              cancelButtonColor: '#FC0324',
              confirmButtonText: '立即兑换',
              closeOnPopstate: false,
              showCancelButton: true,
              cancelButtonText: '取消'
            })
            .then(() => {
              this.exchangeNow(item.id)
            })
            .catch(() => {})
        } else {
          this.$dialog
            .alert({
              message: item.remark,
              className: 'percen_button_alert integral_button_alert PopupIntegral PopupSmall other',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '我知道了',
              closeOnPopstate: false,
              messageAlign: 'center'
            })
            .then(() => {})
            .catch(() => {})
        }
      } else {
        // 兑换商品
        this.$router.push({
          path: '/integralproduct',
          query: {
            itemid: item.integralitemid,
            integralType: item.type == 1 ? 0 : 1,
            integral: this.integral,
            status: item.status,
            itembaseid: item.itembaseid
          }
        })
      }
    },
    // 立即兑换-接口
    exchangeNow(couponid) {
      var that = this,
        url = this.$ajax.exchangeCoupon_URL
      this.$customRequestAjax.post(url, { couponid: couponid }).then((res) => {
        if (res.data.code === 200) {
          this.$dialog
            .confirm({
              title: '兑换成功',
              message: '请至“我的-卡券”内查看',
              className: 'collect_button_alert',
              confirmButtonColor: '#FFFCFC',
              cancelButtonColor: '#FC0324',
              confirmButtonText: '去使用',
              closeOnPopstate: false,
              showCancelButton: true,
              cancelButtonText: '知道了'
            })
            .then(() => {
              this.$router.push('/cashcoupon')
            })
            .catch(() => {
              that.getUserInfo()
            })
        } else {
        }
      })
    },
    // 跳转至抽奖
    goLuck() {
      window.location.href = './static/wx/html/luckyturntable.html?code=77'
    }
  }
}
</script>

<style lang="scss" scoped>
.bottomLine {
  color: #a8a8a8;
  line-height: 0.42rem;
  text-align: center;
}
.over-ell-1,
.over-ell-2,
.over-ell-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.over-ell-1 {
  -webkit-line-clamp: 1;
}
/* 首页弹窗 */
.popWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .block {
    width: 80%;
    background-color: transparent;
    text-align: center;
    font-size: 0;
    position: static;
    img {
      width: 100%;
    }
  }
  .van-icon-close {
    margin-top: 0.4rem;
    font-size: 35px;
    color: #fff;
  }
}

.integral {
  .mr8 {
    margin-right: 0.08rem;
  }
  .mt6 {
    margin-top: 0.06rem;
  }
  .oh:after {
    content: '';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .red {
    color: #fc0324;
  }
  .lh12 {
    line-height: 0.12rem;
  }
  .yellow {
    color: #ffb346;
  }
  .header {
    padding: 0.18rem 0.11rem 0 0.11rem !important;
    height: 2.6rem;
    background: linear-gradient(180deg, #ff4158 0%, #ffd69a 75%, #f5f5f5 100%);
    /*background: url('https://ckysrestatic.ckc8.com/Uploads/static/images/integral/integralbg3.png') no-repeat 0 0;*/
    /*background-size: 100%;*/
    position: relative;
    color: #fff;
    font-size: 0.18rem;
    .topWrap {
      padding: 0.11rem;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.04rem;
      }
      p {
        font-size: 0.22rem;
        font-weight: bold;
      }
    }
    .taskBtn {
      width: 0.7rem;
      height: 0.28rem;
      line-height: 0.28rem;
      font-size: 0.12rem;
      text-align: center;
      border-radius: 0.14rem;
      background: #ffb346;
    }
  }
  .content {
    position: absolute;
    top: 0.73rem;
    width: 100%;
    .titleWrap {
      font-size: 0.18rem;
      color: #fff;
      text-align: center;
      img {
        display: block;
        width: 0.16rem;
        height: 0.16rem;
      }
      .signLabel {
        margin: 0 0.06rem;
      }
      &.titleWrap2 {
        margin: 0.1rem auto;
      }
      &.titleWrap3 {
        margin: 0.15rem auto 0.1rem;
      }
    }
    .integralSeven {
      min-height: 1.7rem;
      background: rgba(255, 255, 255, 1);
      border-radius: 0.04rem;
      margin: 0.1rem 0.11rem 0.11rem;
      padding: 0.05rem 0.08rem;
      color: #6c6c6c;
      &.signinlist {
        min-height: 2rem;
      }
      .item {
        margin: 0.05rem;
        box-sizing: border-box;
        width: 0.74rem;
        height: 0.7rem;
        padding: 0.05rem 0 0.07rem;
        text-align: center;
        border-radius: 0.04rem;
        &.active {
          color: #fff;
          background: #ffb346;
        }
        &.grey {
          color: #6c6c6c;
          background: #eeeeee;
        }
        img {
          margin: 0.04rem auto 0;
          width: 0.2rem;
          height: 0.2rem;
        }
        &:last-child {
          position: relative;
          box-sizing: border-box;
          width: 1.56rem;
          padding-left: 0.14rem;
          text-align: left;
          .reward {
            margin-top: 0.06rem;
            font-size: 0.1rem;
          }
          img {
            position: absolute;
            top: 0.1rem;
            right: 0.14rem;
          }
        }
      }
      .title {
        height: 0.35rem;
      }
      ul {
        li {
          color: #c2ac91;
          text-align: center;
        }
      }
      ol {
        li {
          width: 14.28%;
          .item {
            margin: 0.02rem;
            height: 0.48rem;
            width: auto !important;
            border: 0.005rem solid #fdb170;
            border-radius: 0.04rem;
            padding-left: 0 !important;
            &.today_nosignin {
              background: #eeeeee;
              p {
                color: #ffaa52;
              }
            }
            &.today_yessignin {
              background: #ffb346;
              p {
                color: #ffffff;
              }
            }
            &.notoday_yessignin {
              background: #ffe5bf;
              border-color: #ffe5bf;
            }
            &.notoday_nosignin {
              background: #eeeeee;
              border-color: #eeeeee;
            }
            &.notoday_nosignin_beforedays {
              background: transparent;
              border-color: #e2e1e1;
              p {
                color: #e6ded3;
              }
            }
            img {
              margin-top: 0;
              position: static !important;
            }
            p {
              color: #beac94;
              text-align: center;
              margin-top: 0.02rem;
            }
          }
        }
      }
    }
    .luckDraw {
      margin: 0 0.11rem;
      img {
        width: 100%;
        height: 0.96rem;
      }
    }
    .couponList {
      margin-left: 0.06rem;
      width: 100%;
      ul {
        display: flex;
        overflow-x: scroll;
        li {
          display: flex;
          z-index: 2;
          margin: 0 0.06rem;
          background: #fff;
          .item {
            width: 1.05rem;
            height: 1.22rem;
            background: url('../../assets/images/integral/couponBg.png');
            background-size: 100%;
            text-align: center;
            .price {
              padding: 0.1rem 0 0.04rem;
              color: #fc0324;
              font-size: 0.24rem;
            }
            .exchangeBtn {
              margin: 0.18rem auto 0;
              width: 0.92rem;
              line-height: 0.28rem;
              font-size: 0.12rem;
              text-align: center;
              border-radius: 0.14rem;
              &.active {
                background: #ffb346;
                color: #fff;
              }
              &.grey {
                background: #eaeaea;
                color: #6c6c6c;
              }
            }
          }
        }
      }
    }
    .goodsList {
      margin: 0 0.11rem;
      font-size: 0.12rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .item {
        margin-bottom: 0.1rem;
        padding: 0.1rem;
        background: #fff;
        width: 48.5%;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 1.5rem;
        }
        .img {
          position: relative;
          .soldout {
            position: absolute;
            width: 59%;
            height: 59%;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
          }
        }
        .name {
          margin-top: 0.1rem;
          font-size: 0.14rem;
          color: #303030;
        }
        .costPrice {
          text-decoration: line-through;
        }
      }
    }
  }
  .noDataWrap {
    text-align: center;
    .noDataImg {
      margin-top: 0.64rem;
      width: 1.12rem !important;
      height: 1.12rem !important;
      margin: 0.3rem auto 0.14rem;
    }
    .label {
      font-size: 0.13rem;
      font-weight: 400;
      color: #292929;
      line-height: 0.18rem;
      padding-bottom: 0.3rem;
    }
  }
}
</style>
<style lang="scss">
.integral {
  .van-icon-play {
    float: left !important;
    line-height: 0.25rem !important;
  }
}
.integral_button_alert.percen_button_alert .van-dialog__footer .van-dialog__confirm {
  width: 50%;
}

.integral_button_alert.percen_button_alert.PopupSmall .van-dialog__footer .van-dialog__confirm {
  width: 40%;
}

.percen_button_alert .van-dialog__footer .van-dialog__cancel {
  border: 0.01rem solid #eee;
  color: #323232;
}

.percen_button_alert.van-dialog.PopupIntegral {
  width: 82%;
}

.percen_button_alert.van-dialog.PopupIntegral.PopupSmall {
  width: 70%;
}

.percen_button_alert.van-dialog.PopupIntegral.PopupSmall .van-dialog__content--isolated {
  min-height: auto;
}

.integral_button_alert.percen_button_alert.PopupSmall.other .van-button__text {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  line-height: 100%;
  border: inherit;
  border-radius: inherit;
  transform: translate(-50%, -50%);
  color: #fff;
}

.percen_button_alert .van-dialog__footer .van-button--large {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/integral/integralCenter.vue